<div class="mx-4 -mt-2">
	<div mat-dialog-title>
		<div class="flex flex-row justify-end -mt-2">
			<button
				mat-icon-button
				mat-dialog-close>
				<mat-icon>close</mat-icon>
			</button>
		</div>
	</div>
	<div
		class="mx-4"
		mat-dialog-content>
		<div>
			<p></p>
			<div class="flex items-center gap-2">
				<mat-form-field
					appearance="outline"
					subscriptSizing="dynamic"
					class="w-full">
					<mat-label>
						{{ "janus.mode.advanced.search.placeholder" | translate }}
					</mat-label>
					<input
						cdkFocusInitial
						matInput
						[(ngModel)]="searchKeyword"
						spellcheck="false"
						(keydown.enter)="search()" />
					@if (!isLoading) {
						<mat-icon matIconPrefix>search</mat-icon>
					} @else {
						<mat-spinner
							matIconSuffix
							class="mr-2"
							color="primary"
							diameter="24" />
					}
					@if (searchKeyword && !isLoading) {
						<button
							mat-icon-button
							matIconSuffix
							(click)="searchKeyword = ''">
							<mat-icon>cancel</mat-icon>
						</button>
					}
				</mat-form-field>
				<button
					mat-flat-button
					color="primary"
					style="height: 56px; padding: 0 24px !important"
					[disabled]="isLoading"
					(click)="search()">
					<mat-icon>auto_awesome</mat-icon>
					{{ "janus.dialog.search.button" | translate }}
				</button>
			</div>
			<div class="mt-2 flex items-center gap-1.5 text-xs italic text-gray-400">
				<mat-icon style="font-size: 12px; width: 12px; height: 12px">info</mat-icon>
				<span>{{ "janus.mode.advanced.warning" | translate }}</span>
			</div>
		</div>
		<section class="mt-8 overflow-hidden rounded-xl shadow-sm ring-1 ring-black/10">
			<div class="flex items-center justify-between border-b border-black/10 bg-blue-50 px-6 py-3">
				<div class="flex items-center gap-2">
					<mat-icon class="text-primary">face_retouching_natural</mat-icon>
					<span class="font-bold text-blue-900">{{ "janus.dialog.ai.response.title" | translate }}</span>
				</div>
				<button
					mat-icon-button
					(click)="copyAnswer()">
					<mat-icon>content_copy</mat-icon>
				</button>
			</div>
			@if (isStreaming) {
				<div class="janus-answer select-text p-6 text-base leading-relaxed text-gray-800 whitespace-pre-wrap">
					{{ rawStreamText }}
				</div>
			} @else {
				<div
					class="janus-answer select-text p-6 text-base leading-relaxed text-gray-800"
					[innerHTML]="aiAnswer | safeHtml"></div>
			}
		</section>
		@if (protocols.length > 0) {
			<div class="mt-10 mb-2 text-xs font-bold uppercase tracking-widest text-gray-500">
				{{ "janus.dialog.sources.title" | translate }}
			</div>
			<div class="flex flex-col divide-y divide-gray-200 rounded-lg bg-gray-100">
				@for (protocol of protocols; track protocol.id) {
					<div
						class="flex cursor-pointer items-center justify-between gap-4 px-4 py-2.5 hover:bg-gray-200"
						(click)="viewProtocol(protocol)">
						<span class="truncate font-medium text-gray-900">{{ protocol.label }}</span>
						<div class="flex shrink-0 items-center gap-3">
							@if (getSectionTags(protocol).length > 0) {
								<app-tag
									[tags]="getSectionTags(protocol)"
									[maxTags]="3" />
							}
							@if (protocol.updates?.length > 0) {
								<span
									class="whitespace-nowrap rounded bg-gray-200 px-1.5 py-0.5 text-xs font-mono text-gray-600">
									v{{ protocol.updates.at(-1).major_version }}.{{
										protocol.updates.at(-1).minor_version
									}}
								</span>
							}
						</div>
					</div>
				}
			</div>
		}
	</div>
</div>
